import { useContext } from 'react';
import { LocaleContext, type LocaleContextValue } from './context';
import type { Dictionary } from './dictionary';

function useLocaleContext(): LocaleContextValue {
  const context = useContext(LocaleContext);
  if (!context) {
    // Sağlayıcı olmadan çalışan bir bileşen sessizce Türkçeye düşmemeli:
    // eksik sağlayıcı bir yapılandırma hatasıdır, görünür olmalı.
    throw new Error('useT/useLocale yalnızca <LocaleProvider> içinde kullanılabilir.');
  }
  return context;
}

/** Metinler. Kullanımı: `const t = useT(); t.wallet.title` */
export function useT(): Dictionary {
  return useLocaleContext().t;
}

/** Aktif dil, `Intl` etiketi ve değiştirici. */
export function useLocale(): Omit<LocaleContextValue, 't'> {
  const { locale, intlLocale, setLocale } = useLocaleContext();
  return { locale, intlLocale, setLocale };
}
